module.exports = __webpack_public_path__ + "img/bank_icon.111f8381.png";